export default "__VITE_ASSET__BO5YI0b9__"